import { type AppRoute, Environment, type RouteAccess } from '@/types';
import { oidcClient } from '@/services/oidcClient';
import { appRoutes } from '@/router/router';
import { environment } from '@/environment';

export const canUserAccess = (toRoute: AppRoute): RouteAccess => {
  const isPublicRoute: boolean = !toRoute.restrictedToRoles?.length;

  if (!oidcClient.isAuthenticated) {
    return {
      canAccess: isPublicRoute,
      redirectTo: isPublicRoute ? undefined : appRoutes.loginPage,
    };
  }

  // trying to access login page but have already logged in
  if (toRoute.name === appRoutes.loginPage.name) {
    return { canAccess: false, redirectTo: appRoutes.mainPage };
  }

  const currentUserRoles: string[] = oidcClient.userProfile['groups'] || [];

  const userIsAuthorizedByRole: boolean = !!toRoute.restrictedToRoles?.some((routeRole) => {
    let envRouteRoles: string[] = [];
    if (
      environment.environment === Environment.local ||
      environment.environment === Environment.dev
    ) {
      envRouteRoles = [`dev${routeRole}`, `qa${routeRole}`];
    } else if (environment.environment === Environment.prod) {
      envRouteRoles = [`prod${routeRole}`];
    }

    return currentUserRoles.some((userRole) =>
      envRouteRoles.some((envRouteRole) => envRouteRole === userRole)
    );
  });

  const canAccess = isPublicRoute || userIsAuthorizedByRole;

  return { canAccess, redirectTo: canAccess ? undefined : appRoutes.notAuthorizedPage };
};
